/**
 * 顧客情報
 */
export class CustomerInfo {
    /** 都道府県コード */
    customerPrefectureCode = ""
    /** 顧客コード (999999) */
    customerCode = ""
    /** 枝番 (99) */
    customerBranchNumber = ""
    /** 顧客名称 */
    customerName = ""
    /** 顧客略称名 */
    customerShortName = ""
    /** 郵便番号 (999-9999) */
    customerZipCode = ""
    /** 住所１ */
    customerAddress1 = ""
    /** 住所２ */
    customerAddress2 = ""
    /** 部署名 */
    customerDepartment = ""
    /** 役職 */
    customerPosition = ""
    /** 担当者名 */
    customerContact = ""
    /** 電話番号 */
    customerTel = ""
    /** FAX番号 */
    customerFax = ""
    /** メールアドレス */
    customerMail = ""

    /** 営業拠点 1:出雲 2:横浜 */
    salesOffice = 1
    /** 顧客区分 1:新規 2:既存 */
    customerClassification = 1
    /** 報告書添付ルール 1:個別のみ 2:合算のみ 3:両方 */
    billingRule = 1
    /** 合算請求締め日: 0:なし、 31:月末 */
    deadline = 0
    /** 代理店 0:顧客 1:代理店 */
    agencied = false
    /** 納期計算 0:土日考慮なし 1:土日考慮あり */
    deliveryCalculation = false

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<CustomerInfo>) {
        Object.assign(this, init)
    }

    /**
     * 顧客コード（主キー）
     */
    get customerKey(): string {
        return `${this.customerPrefectureCode}-${this.customerCode}-${this.customerBranchNumber}`
    }
}
